import { User } from './user.model'
import { Group } from './group.model'
import { Comment } from './comment.model'

import { Picture } from './picture.model'

import * as moment from 'moment'
moment.locale('fr')

export enum EventType {
  birth,
  member_birth,
  engagement,
  marriage,
  death,
  holidays,
  announcement,
  other
}

export class Event {
  public id = ''
  public author = new User()
  public type = EventType.other
  public title = ''
  public body = ''
  public beginAt: moment.Moment = null
  public endAt: moment.Moment = null
  public address = ''
  public city = ''
  public zipcode = ''
  public country = ''
  public recurring = false
  public startFeaturing: moment.Moment = null
  public endFeaturing: moment.Moment = null
  public groups: Group[] = []
  public coordinates = { lat: '', lng: '' }
  public pictures: Picture[] = []
  public comments: Comment[] = []

  cast (data: Object) {
    Object.keys(data).forEach((key) => {
      if (this.hasOwnProperty(key)) {
        switch (key) {
          case 'type':
            const type: string = data[key]
            this[key] = typeof EventType[type] !== 'undefined' ? EventType[type] : EventType.other
            break
          case 'beginAt':
          case 'endAt':
          case 'startFeaturing':
          case 'endFeaturing':
            this[key] = data[key] ? moment.utc(data[key]) : null
            break
          case 'author':
            this[key] = new User().cast(data[key])
            break
          case 'groups':
            this[key] = data[key].map(group => new Group().cast(group))
            break
          case 'pictures':
            this[key] = data[key].map(url => new Picture().fromUrl(url))
            break
          case 'comments':
            this[key] = data[key].map(comment => new Comment().cast(comment))
            break
          default:
            this[key] = data[key]
            break
        }
      }
    })

    return this
  }

  getTypeLabel (label: number, date = moment()): string {
    const type = typeof label !== 'undefined' && label !== null ? label : this.type
    const showRecurringLabel = this.recurring && !this.beginAt.isSame(date, 'year')

    switch (type) {
      case EventType.marriage:
        return showRecurringLabel ? 'Anniversaire de Mariage' : 'Mariage'
      case EventType.announcement:
        return 'Annonce'
      case EventType.birth:
      case EventType.member_birth:
        return showRecurringLabel ? 'Anniversaire' : 'Naissance'
      case EventType.death:
        return 'Décès'
      case EventType.engagement:
        return 'Fiançailles'
      case EventType.holidays:
        return 'Vacances'
      case EventType.other:
        return 'Autre'
      default:
        return 'Autre'
    }
  }

  getTypeIcon (label) {
    const type = typeof label !== 'undefined' ? label : this.type
    switch (type) {
      case EventType.marriage:
        return 'fa-heart-o'
      case EventType.announcement:
        return 'comment'
      case EventType.birth:
      case EventType.member_birth:
        return 'fa-birthday-cake'
      case EventType.death:
        return 'ld-cross'
      case EventType.engagement:
        return 'fa-venus-mars'
      case EventType.holidays:
        return 'sun'
      case EventType.other:
        return 'star'
      default:
        return 'star'
    }
  }

  getTypeClass (label) {
    const type = typeof label !== 'undefined' ? label : this.type
    return typeof EventType[type] !== 'undefined' ? EventType[type] : EventType.other
  }
}



// WEBPACK FOOTER //
// ../~/angular2-template-loader!./app/models/event.model.ts